export const isTestDevOrEnv =
  process.env.NODE_ENV === 'test' ||
  (process.env.NODE_ENV === 'development' && window.Cypress);
